<template>
  <div class="service-container">
    <!-- 轮播图区域 - 图片位置留空 -->
    <el-carousel
      :interval="5000"
      arrow="always"
      height="500px"
      class="banner-carousel"
      data-aos="fade-down"
      data-aos-duration="1000"
    >
      <el-carousel-item v-for="(item, index) in banners" :key="index">
        <!-- 这里留出图片位置，您需要自行替换 -->
        <div
          class="banner-placeholder"
          :style="{ backgroundImage: `url(${item.image})` }"
        >
          <div class="banner-content">
            <h2 data-aos="fade-up" data-aos-duration="800">{{ item.title }}</h2>
            <p data-aos="fade-up" data-aos-duration="800" data-aos-delay="200">
              {{ item.subtitle }}
            </p>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <!-- 服务特色区域 -->
    <section
      class="features-section"
      data-aos="fade-up"
      data-aos-duration="800"
    >
      <div class="container">
        <h2 class="section-title">我们的服务特色</h2>
        <p class="section-subtitle">专业、高效、可靠的服务保障</p>

        <el-row :gutter="30" class="features-grid">
          <el-col
            :xs="24"
            :sm="12"
            :md="6"
            v-for="(feature, index) in features"
            :key="index"
          >
            <div
              class="feature-card"
              data-aos="zoom-in"
              data-aos-duration="600"
              :data-aos-delay="index * 200"
            >
              <div class="feature-icon">
                <!-- 图标位置留空，您需要自行替换 -->
                <img :src="feature.icon" alt="icon" />
              </div>
              <h3>{{ feature.title }}</h3>
              <p>{{ feature.description }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- 服务内容区域 -->
    <section
      class="services-section"
      data-aos="fade-up"
      data-aos-duration="800"
    >
      <div class="container">
        <h2 class="section-title">我们的服务内容</h2>
        <p class="section-subtitle">全方位解决方案，满足您的各种需求</p>

        <el-collapse
          v-model="activeCollapse"
          accordion
          class="services-collapse"
        >
          <el-collapse-item
            v-for="(service, index) in services"
            :key="index"
            :name="index"
            :title="service.title"
          >
            <div class="service-content">
              <p>{{ service.description }}</p>
              <!-- 图片位置留空 -->
              <div class="service-image" v-if="service.image">
                <img :src="service.image" alt="service image" />
              </div>
              <el-button
                type="primary"
                :style="{
                  backgroundColor: themeColor,
                  borderColor: themeColor,
                }"
                @click="handleContact"
                class="contact-btn"
              >
                联系我们
              </el-button>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </section>

    <!-- 优势区域 -->
    <section
      class="advantages-section"
      data-aos="fade-up"
      data-aos-duration="800"
    >
      <div class="container">
        <h2 class="section-title">我们的优势</h2>
        <p class="section-subtitle">为什么选择我们</p>

        <el-row :gutter="30">
          <el-col
            :xs="24"
            :sm="12"
            :md="8"
            v-for="(advantage, index) in advantages"
            :key="index"
          >
            <div
              class="advantage-card"
              data-aos="fade-up"
              data-aos-duration="600"
              :data-aos-delay="index * 200"
            >
              <div class="advantage-icon">
                <!-- 图标位置留空，您需要自行替换 -->
                <img :src="advantage.icon" alt="advantage icon" />
              </div>
              <h3>{{ advantage.title }}</h3>
              <p>{{ advantage.description }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- 联系我们区域 -->
    <section class="contact-section" data-aos="fade-up" data-aos-duration="800">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <p class="section-subtitle">随时欢迎您的咨询</p>

        <el-row :gutter="30">
          <el-col :xs="24" :md="12">
            <!-- 图片位置留空 -->
            <div class="contact-image" v-if="contactImage">
              <img :src="contactImage" alt="contact image" />
            </div>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form
              :model="contactForm"
              :rules="contactRules"
              ref="contactForm"
              label-width="100px"
            >
              <el-form-item label="姓名" prop="name">
                <el-input
                  v-model="contactForm.name"
                  placeholder="请输入您的姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="公司" prop="company">
                <el-input
                  v-model="contactForm.company"
                  placeholder="请输入公司名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="phone">
                <el-input
                  v-model="contactForm.phone"
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input
                  v-model="contactForm.email"
                  placeholder="请输入电子邮箱"
                ></el-input>
              </el-form-item>
              <el-form-item label="需求" prop="message">
                <el-input
                  type="textarea"
                  :rows="4"
                  v-model="contactForm.message"
                  placeholder="请描述您的需求"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  :style="{
                    backgroundColor: themeColor,
                    borderColor: themeColor,
                  }"
                  @click="submitContactForm"
                  class="submit-btn"
                >
                  提交需求
                </el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ServicePage",
  data() {
    return {
      themeColor: "#f97d01",
      activeCollapse: 0,

      // 轮播图数据 - 图片位置留空
      banners: [
        {
          image: "", // 替换为您的图片路径
          title: "专业云服务解决方案",
          subtitle: "助力企业数字化转型",
        },
        {
          image: "", // 替换为您的图片路径
          title: "安全可靠的云平台",
          subtitle: "7×24小时专业服务保障",
        },
      ],

      // 服务特色数据 - 图标位置留空
      features: [
        {
          icon: "", // 替换为您的图标路径
          title: "专业团队",
          description: "拥有多年云服务经验的专业技术团队",
        },
        {
          icon: "", // 替换为您的图标路径
          title: "定制方案",
          description: "根据企业需求提供个性化解决方案",
        },
        {
          icon: "", // 替换为您的图标路径
          title: "高效响应",
          description: "7×24小时快速响应，问题及时解决",
        },
        {
          icon: "", // 替换为您的图标路径
          title: "安全保障",
          description: "多重安全防护，确保数据安全可靠",
        },
      ],

      // 服务内容数据 - 图片位置留空
      services: [
        {
          title: "云计算服务",
          description:
            "提供全面的云计算解决方案，包括IaaS、PaaS、SaaS等服务，帮助企业快速构建云环境。",
          image: "", // 替换为您的图片路径
        },
        {
          title: "大数据服务",
          description:
            "专业的大数据处理和分析服务，帮助企业挖掘数据价值，提升业务决策能力。",
          image: "", // 替换为您的图片路径
        },
        {
          title: "人工智能服务",
          description:
            "提供机器学习、深度学习等人工智能技术服务，助力企业智能化转型。",
          image: "", // 替换为您的图片路径
        },
      ],

      // 优势数据 - 图标位置留空
      advantages: [
        {
          icon: "", // 替换为您的图标路径
          title: "经验丰富",
          description: "多年行业经验，服务过数百家企业客户",
        },
        {
          icon: "", // 替换为您的图标路径
          title: "技术领先",
          description: "采用最新技术，保持行业技术领先地位",
        },
        {
          icon: "", // 替换为您的图标路径
          title: "服务完善",
          description: "从咨询到实施，提供一站式完善服务",
        },
      ],

      // 联系我们图片 - 图片位置留空
      contactImage: "", // 替换为您的图片路径

      // 联系表单数据
      contactForm: {
        name: "",
        company: "",
        phone: "",
        email: "",
        message: "",
      },

      // 表单验证规则
      contactRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  mounted() {
    // 初始化AOS动画库
    this.$nextTick(() => {
      import("aos").then((AOS) => {
        AOS.init({
          duration: 800,
          once: true,
        });
      });
    });
  },
  methods: {
    handleContact() {
      // 滚动到联系我们区域
      const contactSection = document.querySelector(".contact-section");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth" });
      }
    },
    submitContactForm() {
      this.$refs.contactForm.validate((valid) => {
        if (valid) {
          // 这里添加表单提交逻辑
          this.$message.success("提交成功，我们会尽快与您联系！");
          this.$refs.contactForm.resetFields();
        } else {
          this.$message.error("请填写完整且正确的信息");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
/* 基础样式 */
.service-container {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;
  color: #333;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.section-title {
  font-size: 32px;
  color: #333;
  text-align: center;
  margin-bottom: 15px;
  font-weight: 500;
}

.section-subtitle {
  font-size: 16px;
  color: #666;
  text-align: center;
  margin-bottom: 50px;
}

/* 轮播图样式 */
.banner-carousel {
  margin-bottom: 60px;
}

.banner-placeholder {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}

.banner-content {
  background-color: rgba(0, 0, 0, 0.5);
  padding: 40px;
  border-radius: 8px;
  max-width: 800px;
}

.banner-content h2 {
  font-size: 42px;
  margin-bottom: 20px;
  color: #fff;
}

.banner-content p {
  font-size: 18px;
  color: #fff;
}

/* 服务特色样式 */
.features-section {
  padding: 60px 0;
  background-color: #f9f9f9;
}

.features-grid {
  margin-top: 40px;
}

.feature-card {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 30px;
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(249, 125, 1, 0.1);
  border-radius: 50%;
}

.feature-icon img {
  max-width: 50%;
  max-height: 50%;
}

.feature-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.feature-card p {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}

/* 服务内容样式 */
.services-section {
  padding: 60px 0;
}

.services-collapse {
  margin-top: 40px;
}

.service-content {
  padding: 20px 0;
}

.service-content p {
  line-height: 1.8;
  margin-bottom: 20px;
  color: #666;
}

.service-image {
  margin: 20px 0;
}

.service-image img {
  width: 100%;
  border-radius: 4px;
}

.contact-btn {
  margin-top: 20px;
}

/* 优势区域样式 */
.advantages-section {
  padding: 60px 0;
  background-color: #f9f9f9;
}

.advantage-card {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 30px;
  transition: all 0.3s ease;
}

.advantage-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.advantage-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(249, 125, 1, 0.1);
  border-radius: 50%;
}

.advantage-icon img {
  max-width: 50%;
  max-height: 50%;
}

.advantage-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.advantage-card p {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}

/* 联系我们样式 */
.contact-section {
  padding: 60px 0;
  background-color: #fff;
}

.contact-image {
  margin-bottom: 30px;
}

.contact-image img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.submit-btn {
  width: 100%;
  margin-top: 20px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .banner-content {
    padding: 20px;
  }

  .banner-content h2 {
    font-size: 28px;
  }

  .banner-content p {
    font-size: 14px;
  }

  .section-title {
    font-size: 28px;
  }

  .section-subtitle {
    font-size: 14px;
    margin-bottom: 30px;
  }
}
</style>
